import { COMPONENT_TYPE, Card, NoData, VariantTable } from 'modules/experiments/components/ui';
import { MONITOR_CARD_HEIGHT } from 'modules/experiments/constants';
import { VariantTableConfidenceLevelContext } from 'modules/experiments/contexts';
import { analyticsReloadOverviewTabData } from 'modules/experiments/ducks/actions';
import {
  getCampaignType,
  getExperimentLoadingState,
  getExperimentOverviewTabErrorState,
  getExperimentOverviewTabLoadingState,
  getExperimentStateStatus,
  getExperimentVariantSummary,
  getExperimentWinningCriteria,
} from 'modules/experiments/ducks/selectors';
import { useExperimentSearchParams, useExperimentsTranslations } from 'modules/experiments/hooks';
import { getVariantSummaryTableColumnData } from 'modules/experiments/utils';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ExperimentNotFound } from 'ui/illustrations/ExperimentNotFound';
import { ExperimentSummaryCardHeader } from './CardHeader';
import { HighlightVariantWinnerWrapper } from './Styled';

export const ExperimentSummary = () => {
  const { t } = useExperimentsTranslations();
  const { experimentId } = useExperimentSearchParams();
  const loading = useSelector(getExperimentLoadingState);
  const isOverviewTabLoading = useSelector(getExperimentOverviewTabLoadingState);
  const hasOverviewTabErrored = useSelector(getExperimentOverviewTabErrorState);
  const { name: winningCriteriaName } = useSelector(getExperimentWinningCriteria);
  const state = useSelector(getExperimentStateStatus);
  const campaignType = useSelector(getCampaignType);
  const [isConfidenceLevelToggleActive, setIsConfidenceLevelToggleActive] = useState(false);
  const columns = getVariantSummaryTableColumnData({ t, winningCriteriaName, state, campaignType });
  const rows = useSelector(getExperimentVariantSummary);
  const dispatch = useDispatch();

  const onClickToggle = () => {
    setIsConfidenceLevelToggleActive((prev) => !prev);
  };

  return (
    <VariantTableConfidenceLevelContext.Provider value={{ isConfidenceLevelToggleActive }}>
      <Card
        testId="experiments-summary"
        cardHeader={
          <ExperimentSummaryCardHeader
            isToggleActive={isConfidenceLevelToggleActive}
            onClickToggle={onClickToggle}
          />
        }
        loading={loading || isOverviewTabLoading}
        height={MONITOR_CARD_HEIGHT.SUMMARY}
      >
        <HighlightVariantWinnerWrapper>
          {!hasOverviewTabErrored ? (
            <VariantTable columns={columns} rows={rows} id="results-tab-variant-table" />
          ) : (
            <NoData
              testId="experiment-summary-table-snapped"
              componentType={COMPONENT_TYPE.CARD}
              Icon={ExperimentNotFound}
              title={t('noData.card.title')}
              subTitle={t('noData.card.subTitle')}
              linkText={t('noData.card.link')}
              onClick={() => dispatch(analyticsReloadOverviewTabData(experimentId))}
            />
          )}
        </HighlightVariantWinnerWrapper>
      </Card>
    </VariantTableConfidenceLevelContext.Provider>
  );
};
